export const COHORT_MEMBER_TYPE = 'Customer';
